import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";
import { scrollToId } from "../lib/ui";

const LOGO_SAND = "https://customer-assets-v7afamib.emergentagent.net/job_peptide-top-ten/artifacts/oqiu41h5_BD41832E-6D22-415D-9C3E-836B39B15F8F.png";

export const Navbar = () => {
  const { count, setOpen } = useCart();
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goToCatalog = (e) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate("/#catalog");
      return;
    }
    scrollToId("catalog");
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-sand/95 backdrop-blur-md border-b border-line" : "bg-transparent"
      }`}
      style={{ top: "28px" }}
    >
      <nav className="mx-auto flex max-w-[1500px] items-center justify-between px-6 py-4 md:px-12">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
          <img src={LOGO_SAND} alt="Southern Fried Peptides" className="h-14 w-14 object-contain md:h-16 md:w-16" />
          <span className="hidden flex-col leading-tight sm:flex">
            <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-ink">Southern Fried Peptides</span>
            <span className="font-mono text-[9px] tracking-[0.28em] uppercase text-rust">Research Grade · Est. 2026</span>
          </span>
        </Link>

        <div className="hidden items-center gap-10 md:flex">
          <a href="#catalog" onClick={goToCatalog} data-testid="nav-catalog" className="group relative font-mono text-xs uppercase tracking-[0.2em] text-ink">
            Catalog
            <span className="absolute -bottom-1 left-0 h-px w-0 bg-rust transition-[width] duration-300 group-hover:w-full" />
          </a>
          <Link to="/#manifesto" data-testid="nav-about" className="group relative font-mono text-xs uppercase tracking-[0.2em] text-ink">
            The Method
            <span className="absolute -bottom-1 left-0 h-px w-0 bg-rust transition-[width] duration-300 group-hover:w-full" />
          </Link>
          <Link to="/#coa" data-testid="nav-coa" className="group relative font-mono text-xs uppercase tracking-[0.2em] text-ink">
            Purity
            <span className="absolute -bottom-1 left-0 h-px w-0 bg-rust transition-[width] duration-300 group-hover:w-full" />
          </Link>
        </div>

        <button
          data-testid="cart-button"
          onClick={() => setOpen(true)}
          className="group flex items-center gap-2 border border-ink bg-ink px-4 py-2.5 text-cream transition-colors duration-300 hover:bg-transparent hover:text-ink"
        >
          <ShoppingBag className="h-4 w-4" strokeWidth={1.5} />
          <span className="font-mono text-xs uppercase tracking-[0.15em]">Cart</span>
          <span data-testid="cart-count" className="font-mono text-xs">[{count}]</span>
        </button>
      </nav>
    </header>
  );
};
